import { hover } from "@testing-library/user-event/dist/hover";

function NXInvisible({ className }: { className?: string }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} stroke-black hover:stroke-primary-400 transition-all duration-150 ease-linear`}
    >
      <path d="M3.62914 3.6244C4.62188 2.9793 5.7722 2.5 6.99997 2.5C9.78997 2.5 12.18 4.97503 13.23 6.2463C13.3958 6.45302 13.4876 6.72159 13.4876 7.00006C13.4876 7.27853 13.3958 7.5471 13.23 7.75382C12.6512 8.45457 11.6652 9.52108 10.4296 10.3372M8.49997 11.2697C8.01759 11.4156 7.51561 11.5001 6.99997 11.5001C4.20997 11.5001 1.81997 9.02509 0.769968 7.75382C0.604128 7.5471 0.512329 7.27853 0.512329 7.00006C0.512329 6.72159 0.604128 6.45302 0.769968 6.2463C1.10264 5.84352 1.56982 5.31991 2.14162 4.79247" />
      <path d="M8.41421 8.41427C9.19526 7.63322 9.19526 6.36689 8.41421 5.58584C7.63316 4.8048 6.36683 4.8048 5.58578 5.58584" />
      <path d="M13.5 13.5L0.5 0.5" />
    </svg>
  );
}

export default NXInvisible;
